import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { StateStorageService } from './state-storage.service';
import { AccountService } from './account.service';
import { AuthServerProvider } from './auth-jwt.service';

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService implements CanActivate {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private authServerProvider: AuthServerProvider,  
    private stateStorageService: StateStorageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    const authorities = route.data['authorities'];
    return this.checkLogin(authorities);
  }

  checkLogin(authorities: string[]){
    return this.checkAccount().then(account => {
      if (!authorities || authorities.length === 0) {
        return true;
      }

      if (account) {
        const hasAnyAuthority = this.accountService.hasAnyAuthority(authorities);
        if (hasAnyAuthority) {
          return true;
        }
        if (isDevMode()) {
          console.error('User has not any of required authorities: ', authorities);
        }
        return false;
      }
      this.router.navigate(['/authentication/login']);
      this.authServerProvider.logout();
      return false;
    });
  }
  checkAccount(): Promise<any> {
    return new Promise((resolve, cal) => {
      let acc = this.accountService.getInfo();
      if (acc) {
        resolve(true);
      } else {
        setTimeout(() => {
          let acc = this.accountService.getInfo();
          resolve(acc ? true : false);
        }, 1000)
      }
    })
  }
}
